// extracted by mini-css-extract-plugin
export default {"CalendarWrapper":"calendar_CalendarWrapper_BZRcv","BoardWrapper":"calendar_BoardWrapper_sQlQ4"};